import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { CreateUrlInput, CreateUrlMutation } from '@/gql/graphql';

const CREATE_URL_MUTATION = graphql(`
  mutation CreateUrl($input: CreateUrlInput!) {
    createUrl(input: $input)
  }
`);

const useCreateUrl = (
  options?: UseMutationOptions<CreateUrlMutation, unknown, CreateUrlInput>
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CREATE_URL_MUTATION, { input });
    },
    ...options,
  });
};

export default useCreateUrl;
